import React from 'react';
import { Link } from 'react-router-dom';

const Cards = () => {
  const cardsData = [
    {
      id: 1,
      tag: 'Harm Reduction Diversion',
      icon: 'fa-scale-balanced',
      frontContent: `L.I.F.E.'s Alternative: L.E.A.D Diversion Program`,
      sectionId: 'program-3',
      imgSrc: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?q=80&w=1200&auto=format&fit=crop',
      backContent: `A pre-booking diversion program connecting individuals to community-based care, housing, and case management instead of jail.`
    },
    {
      id: 2,
      tag: 'Reintegration & Transition',
      icon: 'fa-handshake-angle',
      frontContent: 'Back2LIFE Reintegration & Transition Support Program',
      sectionId: 'program-1',
      imgSrc: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?q=80&w=1200&auto=format&fit=crop',
      backContent: `Providing wrap-around case management, discharge planning, and job placement to reduce recidivism in Schenectady County Jail.`
    },
    {
      id: 3,
      tag: 'Violence Prevention & Intervention',
      icon: 'fa-shield-heart',
      frontContent: '1Life2Live Violence Prevention & Intervention Program',
      sectionId: 'program-2',
      imgSrc: 'https://images.unsplash.com/photo-1529156069898-49953e39b3ac?q=80&w=1200&auto=format&fit=crop',
      backContent: `Street outreach, conflict mediation, and crisis intervention aimed at stopping gun violence and supporting high-risk youth.`
    }
  ];

  return (
    <div className="home-programs-container">
      <div className="home-programs-header">
        <span className="section-subtitle">OUR CORE IMPACT</span>
        <h2 className="section-title">Programs & Community Initiatives</h2>
        <p className="section-description">
          We provide proactive, evidence-based programs designed to save lives, restore families, and foster long-term community peace.
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
        {cardsData.map((card) => (
          <Link
            key={card.id}
            to={`/programs#${card.sectionId}`}
            className="home-program-card group"
          >
            <div className="card-image-wrapper">
              <img
                alt={card.frontContent}
                src={card.imgSrc}
                className="card-image"
              />
              <div className="card-gradient-overlay" />
            </div>

            <div className="card-content">
              <div className="card-badge">
                <i className={`fa-solid ${card.icon}`}></i>
                <span>{card.tag}</span>
              </div>

              <h3 className="card-title">{card.frontContent}</h3>
              <p className="card-description">{card.backContent}</p>

              <div className="card-action">
                <span>View Program Details</span>
                <i className="fa-solid fa-arrow-right icon-arrow"></i>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default Cards;
